import React, {useEffect, useState} from "react";
import organisations_api from "../../api/protected/organisations";
import team_categories_api from "../../api/team_categories";
import {useSearchParams} from "react-router-dom";
import TeamPeopleContainer from "../../containers/TeamPeopleContainer";
import InfoRightPopUp from "../InfoRightPopUp";
import Select from "react-select"
import styles from "../../utils/ReactSelectStyles";
import countries from "i18n-iso-countries";
import enLocale from "i18n-iso-countries/langs/en.json";
countries.registerLocale(enLocale);


const TeamForm = (props) => {
    const [organisations, setOrganisations] = useState([]);
    const [organisationID, setOrganisationID] = useState(null);
    const [organisationName, setOrganisationName] = useState();
    const [teamName, setTeamName] = useState(props.teamName ?? "");
    const [teamDescription, setTeamDescription] = useState("");

    const [teamPeople, setTeamPeople] = useState([])
    const [buttonText, setButtonText] = useState("")
    const submit = props.submit
    const isNew = props.isNew
    const editor = props.editor

    const [showNameError, setShowNameError] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();


    const [country, setCountry] = useState("");
    const [countrySelected, setCountrySelected] = useState();
    const [countryCodes, setCountryCodes] = useState([]);
    const [showCountryReminder, setShowCountryReminder] = useState(false);
    const [categories, setCategories] = useState([]);
    const noneCategory = { id: null, name: "None" };
    const [categorySelected, setCategorySelected] = useState(noneCategory);


    useEffect(() => {
        if (!props.buttonText) return;
        setButtonText(props.buttonText)
    }, [props.buttonText])

    useEffect(() => {
        if (!props.teamName) return;
        setTeamName(props.teamName ?? "");
    }, [props.teamName])

    const desc_char_lim = 50 // Max 50 characters

    useEffect(() => {
        if (!props.teamDescription) return;
        setTeamDescription((props.teamDescription ?? "").slice(0, desc_char_lim))
    }, [props.teamDescription])

    useEffect(() => {
        if (!props.organisationId) return;
        if (props.organisationId === 0) return;
        setOrganisationID(props.organisationId);
    }, [props.organisationId])

    useEffect(() => {
        getOrganisations();
        getCountries();
        getCategories();
    }, [])



    useEffect(() => {
        if (props.searchName !== undefined) {
            setTeamName(props.searchName)
            searchParams.delete("name")
            setSearchParams(searchParams)
        }
    },[props.searchName])

    useEffect(() => {
        if (props.organisationId !== null) {
            setOrganisationID(props.organisationId)
            searchParams.delete("organisation")
            setSearchParams(searchParams)
        }
    },[props.organisationId])


    const getCountries = () => {
        const items = Object.entries(
            countries.getNames("en", { select: "official" })
        ).map(([code, name]) => ({ code, name }))
            .sort((a, b) => a.name.localeCompare(b.name));

        setCountryCodes(items);
        setCountry("GB");
        setCountrySelected({ code: "GB", name: "United Kingdom" });
    };


    const getCategories = () => {
        team_categories_api.getTeamCategories().then(response => {
            setCategories(response.data.categories ?? []);
        })
    };


    const getOrganisations = () => {
        let response = organisations_api.getOrganisations();
        response.then(response => {
            setOrganisations(response.data.organisations);
            if (props.organisationId) {
                for(let i=0;i<response.data.organisations.length;i++) {
                    if (response.data.organisations[i].id === props.organisationId){
                        setOrganisationName(response.data.organisations[i].name);
                        break;
                    }
                }
            } else {
                if (response.data.organisations.length > 0) {
                    setOrganisationID(response.data.organisations[0].id)
                    setOrganisationName(response.data.organisations[0].name)
                }
            }
        })
    }

    const updatePeople = (person) => {
        if(!person) return;
        let temp = [...teamPeople]
        temp.push(person)
        setTeamPeople(temp)
    }

    const deletePerson = (ev, idx) => {
        let temp = [...teamPeople]
        temp.splice(idx, 1)
        setTeamPeople(temp)
    }

    const updatePerson = (person, idx) => {
        let temp = [...teamPeople]
        temp[idx] = person
        setTeamPeople(temp)
    }

    const formSubmit = (ev)=> {
        ev.preventDefault();
        const nameTrimmed = (teamName ?? "").trim()

        if (!nameTrimmed) {
            setShowNameError(true)
            return
        }
        setShowNameError(false)

        if (!countrySelected || !countryCodes) {
            setShowCountryReminder(true)
            return
        }

        let body = {
            "name": nameTrimmed,
            "description": teamDescription,
            "organisation_id": organisationID,
            "country": countrySelected.code,
            "category_id": categorySelected?.id ?? null,
        }
        submit(body, teamPeople)
    }


    return (
        <>
            <div className="team-form-container">
                <div className="teams-form-title">Organisation Details</div>
                <div className="field-input">
                    <div className="field-input-entry">
                        <div className="label">Organisation</div>
                        {!isNew ?
                            <input className="organisation-input" type="text" value={props.team ? props.team.organisation_name : organisationName}
                                   disabled={true} required/>
                            :
                            <select onChange={(ev) => setOrganisationID(ev.target.value)} value={organisationID}>
                                {organisations && organisations.map((organisation, idx) => {
                                    return <option value={organisation.id} key={"organisations-" + idx}>{organisation.name}</option>
                                })}
                            </select>
                        }
                    </div>
                </div>
                <div className="field-input">
                    <div className="label">Team Name <InfoRightPopUp text={"This information will appear in the survey invitations emails and reports."} /></div>
                    <div className="field-input-entry">
                        <input className="team-name-input" type="text" value={teamName} required disabled={!editor}
                               onChange={(ev) => {
                                   const v = ev.target.value;
                                   setTeamName(v)

                                   if (showNameError) {
                                       setShowNameError(v.trim().length === 0)
                                   }
                               }}
                               aria-invalid={showNameError ? "true" : "false"}
                               aria-describedby={showNameError ? "team-name-error" : undefined}
                        />
                    </div>
                    {showNameError && (
                        <div
                            id="team-name-error"
                            className="field-error"
                            style={{ color: "#cc0011", fontStyle: "italic", marginTop: 4 }}
                        >
                            Team Name is mandatory
                        </div>
                    )}
                </div>
                <div className="field-input">
                    <div className="field-input-entry">
                        <div className="label">Team Description <InfoRightPopUp text={"Short description for your reference only (max 50 characters)"} /> </div>
                        <input type="text" maxLength={desc_char_lim} value={teamDescription} disabled={!editor}
                               onChange={(ev) => setTeamDescription(ev.target.value)}
                        />
                        <div
                            className="help-text"
                            style={{
                                marginTop: 4,
                                fontSize: 12,
                                fontStyle: "italic",
                                color: teamDescription.length >= desc_char_lim ? "#cc0011" : "#666"
                            }}
                        >
                            {teamDescription.length}/{desc_char_lim} characters
                        </div>
                    </div>
                </div>
                <div className="field-input">
                    <div className="field-input-entry">
                        <div className="label">Team Location <InfoRightPopUp text={"Please select the country where the team members are predominantly based. This is used to support benchmarking analysis."}/> </div>
                        <Select name="traits.country" options={countryCodes}
                                getOptionLabel={option => option.name}
                                getOptionValue={option => option.code}
                                value={countrySelected}
                                placeholder=""
                                onChange={ev => {
                                    setCountry(ev?.code ?? "");
                                    setCountrySelected(ev ?? null)
                                    setShowCountryReminder(false)
                                }}
                                onBlur={() => {
                                    if (!countrySelected?.code) setShowCountryReminder(true)
                                }}
                                styles={styles.registerStyles}
                                required={true}
                        />
                        {showCountryReminder ? <div className="messages">This field is required.</div> : null}
                    </div>
                </div>
                <div className="field-input">
                    <div className="field-input-entry">
                        <div className="label">Team Category <InfoRightPopUp text={"Optional. Used to compare this team against a matching benchmark overlay, such as HR."}/></div>
                        <Select name="team.category" options={[noneCategory, ...categories]}
                                getOptionLabel={option => option.name}
                                getOptionValue={option => option.id ?? ""}
                                value={categorySelected}
                                placeholder=""
                                isDisabled={!editor}
                                onChange={ev => setCategorySelected(ev ?? noneCategory)}
                                styles={styles.registerStyles}
                        />
                    </div>
                </div>

                {!isNew && editor?
                    <div className="field-input">
                        <button className="update-organisation-button link" onClick={formSubmit}>
                                {buttonText && buttonText}
                        </button>
                    </div>
                    : null
                }
            </div>
            {isNew ?
                <>
                    <div className="team-form-container">
                        <TeamPeopleContainer people={teamPeople} organisation_id={organisationID} isNew={isNew} editor={true}
                                             updatePeople={updatePeople.bind(this)}
                                             updatePerson={updatePerson.bind(this)}
                                             deletePerson={deletePerson.bind(this)}
                        />
                    </div>
                    <div className="field-input">
                        <button className="update-organisation-button link" onClick={formSubmit}>
                            {buttonText && buttonText}
                        </button>
                    </div>
                </>
                : null
            }
        </>
    )
}

export default TeamForm